import {
  FETCH_ALL_PRODUCT_SUBTYPES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PRODUCT_SUBTYPES](state, productSubtypes) {
    state.all = productSubtypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productSubtype/mutations.js